import { lazy, Suspense } from 'react';
import type { ClassKey } from 'keycloakify/login';
import DefaultPage from 'keycloakify/login/DefaultPage';

import './main.css';

import { useI18n } from './i18n';
import type { KcContext } from './KcContext';
import Error from './pages/Error/Error';
import LoginMobileId from './pages/LoginMobileId/LoginMobileId';
import LoginPageExpired from './pages/LoginPageExpired/LoginPageExpired';
import LoginSelectForm from './pages/LoginSelectForm/LoginSelectForm';
import LoginSms from './pages/LoginSms/LoginSms';
import LoginUsername from './pages/LoginUsername/LoginUsername';
import LogoutConfirm from './pages/LogoutConfirm/LogoutConfirm';
import Template from './Template';
const UserProfileFormFields = lazy(() => import('keycloakify/login/UserProfileFormFields'));

const doMakeUserConfirmPassword = true;

export default function KcPage(props: { kcContext: KcContext }) {
	const { kcContext } = props;

	const { i18n } = useI18n({ kcContext });

	return (
		<Suspense fallback={<div />}>
			{(() => {
				switch (kcContext.pageId) {
					case 'login-select.ftl':
						return (
							<LoginSelectForm
								{...{ kcContext, i18n, classes }}
								Template={Template}
								doUseDefaultCss={false}
							/>
						);
					case 'login-sms.ftl':
						return (
							<LoginSms
								{...{ kcContext, i18n, classes }}
								Template={Template}
								doUseDefaultCss={false}
							/>
						);

					case 'login-username.ftl':
						return (
							<LoginUsername
								{...{ kcContext, i18n, classes }}
								Template={Template}
								doUseDefaultCss={false}
							/>
						);

					case 'mobile-push.ftl':
						return (
							<LoginMobileId
								{...{ kcContext, i18n, classes }}
								Template={Template}
								doUseDefaultCss={false}
							/>
						);

					case 'logout-confirm.ftl':
						return (
							<LogoutConfirm
								{...{ kcContext, i18n, classes }}
								Template={Template}
								doUseDefaultCss={false}
							/>
						);

					case 'login-page-expired.ftl':
						return (
							<LoginPageExpired
								{...{ kcContext, i18n, classes }}
								Template={Template}
								doUseDefaultCss={false}
							/>
						);

					case 'error.ftl':
						return (
							<Error
								{...{ kcContext, i18n, classes }}
								Template={Template}
								doUseDefaultCss={false}
							/>
						);

					default:
						return (
							<DefaultPage
								kcContext={kcContext}
								i18n={i18n}
								classes={classes}
								Template={Template}
								doUseDefaultCss={false}
								UserProfileFormFields={UserProfileFormFields}
								doMakeUserConfirmPassword={doMakeUserConfirmPassword}
							/>
						);
				}
			})()}
		</Suspense>
	);
}

const classes: { [key in ClassKey]?: string } = {};
